import * as yup from 'yup'

export const schemaUser = yup.object().shape({
  evidence: yup.string().required(),
})

export default schemaUser
